import React from 'react';
import PropTypes from 'prop-types';

// Components
import Link from '../../Link/Link';

const FacebookButton = ({ postLink, title }) => (
  <Link
    className="social-button-link"
    target="_blank"
    rel="noopener noreferrer"
    href={`https://www.facebook.com/sharer/sharer.php?u=${postLink}`}
    title={title}
  >
    <div className="social-button-icon flex-center">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM15.1159 7.992L13.9863 7.99249C13.1006 7.99249 12.9291 8.41339 12.9291 9.031V10.393H15.0415L14.7665 12.5262H12.9291V18H10.7261V12.5262H8.88409V10.393H10.7261V8.81976C10.7261 6.99408 11.8412 6 13.4698 6C14.25 6 14.9205 6.05804 15.1159 6.08405V7.992Z"
          fill="#1A76F2"
        />
      </svg>
    </div>
  </Link>
);

FacebookButton.propTypes = {
  postLink: '',
};

FacebookButton.propTypes = {
  title: PropTypes.string.isRequired,
  postLink: PropTypes.string.isRequired,
};

export default FacebookButton;
